import { render, staticRenderFns } from "./tab-released.vue?vue&type=template&id=31bae365&scoped=true"
import script from "./tab-released.vue?vue&type=script&lang=js"
export * from "./tab-released.vue?vue&type=script&lang=js"
import style0 from "./tab-released.vue?vue&type=style&index=0&id=31bae365&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bae365",
  null
  
)

export default component.exports